var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNopendingdata({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-reading-list",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-reading-list:not(.animated) .animable {opacity: 0;}svg#freepik_stories-reading-list.animated #freepik--Floor--inject-47 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-reading-list.animated #freepik--Plant--inject-47 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-reading-list.animated #freepik--Character--inject-47 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-reading-list.animated #freepik--speech-bubble--inject-47 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}            @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-47",
    style: {
      transformOrigin: "256.8500061035156px 464.9200134277344px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.88,464.92c0,.14-99.87.26-223,.26s-223.06-.12-223.06-.26,99.85-.26,223.06-.26S479.88,464.77,479.88,464.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "256.8500061035156px 464.9200134277344px"
    },
    id: "elb032ks4ns4g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-47",
    style: {
      transformOrigin: "399.5160369873047px 372.5099334716797px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.63,378.34c9.62,3.36,22.16.36,30.39-5.65s14.15-14.62,19.4-23.35c2.23-3.73,4.42-7.61,5.13-11.9s-.34-9.12-3.66-11.92c-5.17-4.35-13.09-2.14-19,1.2a65.4,65.4,0,0,0-32.3,51.62",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "434.17542266845703px 351.42083168029785px"
    },
    id: "elixo51szepg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,401.36c5.78,7.62,15.7,11,25.26,11.45s19-2.19,27.91-5.62c3.24-1.24,6.79-2.95,7.9-6.23a8,8,0,0,0-1.69-7.36,16.59,16.59,0,0,0-6.45-4.39c-8.79-3.74-18.85-3.92-28.1-1.52s-17.32,7.76-24.83,13.67",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "447.67554664611816px 399.4815483093262px"
    },
    id: "el6lo2neuvjxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.49,337.13c8,.16,14-6.81,17.59-13.91a51.6,51.6,0,0,0,4.74-32.16c-.73-4.07-2.27-8.46-5.91-10.42s-8.51-.67-11.61,2.16-4.8,6.87-6,10.88c-4.28,13.83-3.36,29.73,1.23,43.45",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "416.0702257156372px 308.41629791259766px"
    },
    id: "elzbmst06x3zg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.33,381.17c13.58-23.1,15.84-51.37,7.82-76.94-1.3-4.15-3.75-8.89-8.09-9.17-4.8-.3-7.82,5.06-9.14,9.68-4.66,16.24-3.67,33.48-2.64,50.34.64,10.39,4.2,19.27,12.05,26.09",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "380.1007890701294px 338.1089744567871px"
    },
    id: "elixcvevoetoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.22,390.67a55.56,55.56,0,0,0-32.94-34.93c-3.61-1.35-8.19-2.13-10.88.63s-1.82,7.23-.13,10.61c2.73,5.45,7.17,9.84,11.59,14,4,3.83,8.2,7.67,13.28,9.9s14.43,2.78,19.08-.25",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "343.4504852294922px 373.62116622924805px"
    },
    id: "el7nzfai6mi23",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.38,331.32s-.07.08-.24.21l-.73.57-2.84,2.12-2.07,1.53c-.74.57-1.51,1.24-2.36,1.93-1.68,1.4-3.67,2.91-5.67,4.81l-3.2,2.91c-1.11,1-2.17,2.17-3.32,3.3-2.34,2.25-4.6,4.87-7,7.58a149.21,149.21,0,0,0-24.81,40.14c-1.33,3.39-2.67,6.59-3.63,9.68-.5,1.54-1.06,3-1.47,4.45l-1.17,4.16c-.81,2.64-1.27,5.09-1.78,7.22-.23,1.07-.48,2.06-.66,3s-.31,1.76-.44,2.53c-.27,1.48-.48,2.65-.63,3.5-.08.36-.13.66-.18.9s-.07.31-.09.31a1.54,1.54,0,0,1,0-.32c0-.24.07-.54.12-.91.12-.86.3-2,.51-3.52.12-.77.25-1.62.39-2.54s.39-1.93.61-3c.48-2.14.91-4.61,1.69-7.26.36-1.34.74-2.74,1.14-4.19s.94-2.93,1.43-4.48c1-3.11,2.27-6.33,3.6-9.74a146.32,146.32,0,0,1,24.91-40.3c2.45-2.7,4.74-5.32,7.1-7.56,1.16-1.14,2.24-2.28,3.36-3.29l3.24-2.89c2-1.88,4-3.37,5.74-4.75.87-.68,1.65-1.33,2.41-1.89l2.1-1.49,2.92-2,.77-.51C450.28,331.36,450.37,331.31,450.38,331.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.2308006286621px 381.744384765625px"
    },
    id: "eluqp9py2n8pk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.36,395.36a5.3,5.3,0,0,1-.94-.15c-.6-.11-1.48-.35-2.64-.54a72,72,0,0,0-68.06,23,74.63,74.63,0,0,0-6.07,7.82c-.68,1-1.13,1.74-1.48,2.25a4.78,4.78,0,0,1-.55.77,4.91,4.91,0,0,1,.44-.84c.31-.53.73-1.34,1.38-2.32a66.54,66.54,0,0,1,5.94-8A70.59,70.59,0,0,1,455,393a65,65,0,0,1,9.85,1.41c1.15.23,2,.5,2.63.65A7.09,7.09,0,0,1,468.36,395.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "428.4899597167969px 410.66175842285156px"
    },
    id: "el5nb6guyb3vt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.22,289.87a1.25,1.25,0,0,1-.05.36c-.06.27-.13.61-.22,1-.21,1-.51,2.29-.89,4-.78,3.45-2,8.43-3.47,14.58-3,12.3-7.34,29.24-11.87,48-2.25,9.39-4.28,18.36-6,26.54s-3.19,15.57-4.28,21.8c-.59,3.11-1,5.94-1.45,8.42s-.75,4.61-1,6.36-.47,3.06-.62,4c-.08.43-.14.77-.18,1s-.07.36-.09.36a1.94,1.94,0,0,1,0-.36c0-.28.07-.62.12-1.06.12-1,.29-2.32.51-4s.51-3.9.9-6.39.79-5.32,1.35-8.43c1-6.25,2.46-13.65,4.16-21.85s3.74-17.17,6-26.57c4.53-18.77,8.95-35.69,12-48l3.67-14.53c.43-1.68.77-3,1-3.95.11-.42.2-.75.28-1A1.4,1.4,0,0,1,418.22,289.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "403.1558208465576px 358.07997131347656px"
    },
    id: "elpwdewz65k8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.05,424.51a1.09,1.09,0,0,1-.09-.28l-.18-.83c-.17-.79-.39-1.87-.67-3.22-.58-2.79-1.34-6.85-2.21-11.88-1.74-10.05-3.81-24-5.07-39.53-.62-7.77-1-15.18-1.11-21.93s-.05-12.83.16-17.93c.06-2.55.23-4.85.34-6.88s.24-3.76.38-5.18.22-2.47.3-3.27c0-.34.07-.62.09-.85s0-.29.06-.29a1.36,1.36,0,0,1,0,.3c0,.23,0,.51,0,.85,0,.8-.11,1.9-.19,3.28s-.2,3.16-.27,5.18-.21,4.33-.24,6.88c-.15,5.09-.17,11.16,0,17.9s.54,14.13,1.15,21.88c1.27,15.5,3.26,29.45,4.89,39.52.81,5,1.5,9.1,2,11.9.23,1.37.42,2.45.55,3.24.05.34.09.62.13.85A1.27,1.27,0,0,1,387.05,424.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "382.3686294555664px 368.4750213623047px"
    },
    id: "elwtge94mcdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.05,427.44a4.64,4.64,0,0,1-.35-.79l-.89-2.33c-.2-.51-.41-1.07-.64-1.68l-.87-1.95c-.31-.7-.65-1.45-1-2.25s-.8-1.59-1.23-2.46-.91-1.75-1.39-2.69L380,410.45c-1.09-2-2.5-4-3.86-6.13A145.44,145.44,0,0,0,366,391.26a160.56,160.56,0,0,0-11.74-11.75c-1.95-1.64-3.74-3.29-5.54-4.67l-2.57-2-2.44-1.8c-1.54-1.16-3-2.14-4.26-3s-2.37-1.61-3.29-2.16L334,364.5a4.25,4.25,0,0,1-.71-.5,4.81,4.81,0,0,1,.78.39l2.16,1.23c.95.53,2.08,1.23,3.36,2.08s2.77,1.78,4.33,2.93l2.48,1.77,2.6,2c1.83,1.36,3.63,3,5.6,4.64a151.81,151.81,0,0,1,11.82,11.76A137,137,0,0,1,376.66,404c1.35,2.18,2.75,4.18,3.83,6.19.56,1,1.1,1.95,1.63,2.88l1.35,2.72c.42.88.86,1.69,1.2,2.49l1,2.28.82,2c.22.62.41,1.19.59,1.71.32,1,.58,1.76.78,2.36A3.31,3.31,0,0,1,388.05,427.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.6700134277344px 395.7200012207031px"
    },
    id: "elhrrn1u0olrt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.35,358.12c0,.1-1.65.1-4.29.24a82.42,82.42,0,0,0-10.25,1.24,79.33,79.33,0,0,0-10,2.61c-2.51.83-4,1.43-4.08,1.34a3.88,3.88,0,0,1,1-.55c.67-.33,1.66-.75,2.91-1.22A61.47,61.47,0,0,1,441,357.91c1.33,0,2.41,0,3.15.06A3.69,3.69,0,0,1,445.35,358.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "431.0400085449219px 360.7344641685486px"
    },
    id: "elfg6oa176urs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.59,408.13c-.2.1-1.73-4.32-5.59-8.42s-8.11-6-8-6.2a9.41,9.41,0,0,1,2.76,1.22,24.35,24.35,0,0,1,9.8,10.56A9.92,9.92,0,0,1,455.59,408.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "448.79393768310547px 400.82082509994507px"
    },
    id: "el0mrv3hl0heif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.66,308.62c.13.14-2.37,2.62-5.09,6s-4.67,6.29-4.83,6.19,1.56-3.21,4.33-6.6A28.05,28.05,0,0,1,420.66,308.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "415.6972932815552px 314.7162480354309px"
    },
    id: "elhwin5qegjyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.46,294.46c.18,0,.73,2.37,1.24,5.36s.78,5.43.61,5.46-.73-2.37-1.24-5.36S412.29,294.49,412.46,294.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.3849738240242px 299.87011909484863px"
    },
    id: "elx536v3uhu6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.07,338.91c.15.08-1.62,3.82-4,8.36s-4.38,8.15-4.54,8.07,1.62-3.83,4-8.37S386.91,338.83,387.07,338.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "382.7994546890259px 347.1249942779541px"
    },
    id: "elb2joopyt3jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,323.82c.16-.08,1.67,2.63,3.37,6.05s2.95,6.25,2.8,6.33-1.67-2.63-3.37-6.05S371.79,323.9,372,323.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.08001232147217px 330.0099811553955px"
    },
    id: "el7vnfpde8eu5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.74,375.42c0,.19-2.74-.34-6.1-.57s-6.1-.1-6.12-.29,2.74-.6,6.17-.35S349.78,375.26,349.74,375.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "343.6301441192627px 374.7959008216858px"
    },
    id: "elkbfr9lnlt7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.91,421.05l7.56,39.74a5.56,5.56,0,0,0,5.47,4.53h22.33a5.56,5.56,0,0,0,5.49-4.66l6.57-39.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.6199951171875px 443.1849842071533px"
    },
    id: "elw2e3woqn0km",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.37 433.97 410.06 433.97 412.33 421.05 364.91 421.05 367.37 433.97",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "388.6199951171875px 427.50999450683594px"
    },
    id: "el5lsbqia7wtb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.37 433.97 368.26 438.68 409.41 438.68 410.06 433.97 367.37 433.97",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "388.7149963378906px 436.3249969482422px"
    },
    id: "elr458scau9h",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-47",
    style: {
      transformOrigin: "238.7125015258789px 278.8546447753906px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.59,459.71l2.58-11,21.43.53-1.79,15.65-1.36.11c-6.07.41-30.88,1.66-35,.48C175,464.15,193.59,459.71,193.59,459.71Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "198.18096351623535px 457.34214782714844px"
    },
    id: "elokvfxng2gqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk5y521s4cnm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "211.80500030517578px 461.6086187362671px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.83,464.81a7.63,7.63,0,0,1,2.75-4.73,7.4,7.4,0,0,1,5.12-1.66l.08,6.15Z",
    id: "elbtijjn0jrcb",
    style: {
      transformOrigin: "211.80500030517578px 461.6086187362671px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ellc01z0du4dq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "197.25355911254883px 464.02381134033203px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.49,462.21s-6.53,2-5.7,3,26,.75,37-.36l0-.49-29.3.62S185.77,462.24,184.49,462.21Z",
    id: "elnv551olfhjh",
    style: {
      transformOrigin: "197.25355911254883px 464.02381134033203px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216.11,464.37a1.65,1.65,0,0,1-.38.05l-1.08.08-4,.22c-3.37.17-8,.33-13.2.4s-9.83,0-13.21,0l-4-.12-1.09,0-.37,0a1.59,1.59,0,0,1,.38,0h1.08l4,0c3.37,0,8,0,13.2,0s9.82-.21,13.19-.33l4-.13,1.09,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "197.44499969482422px 464.7605370283127px"
    },
    id: "eligqwo5y3aj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.48,465.36a9.06,9.06,0,0,0-.77-1.9,8.84,8.84,0,0,0-1.39-1.52,3,3,0,0,1,1.61,1.37A3,3,0,0,1,186.48,465.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "185.40740764141083px 463.6499938964844px"
    },
    id: "el38qokxtrhey",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.93,462c-.06,0-.38-.33-.71-.84s-.54-.94-.48-1,.38.34.71.84S193,461.94,192.93,462Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "192.33639627695084px 461.0770069360733px"
    },
    id: "elmgofk2371f9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7,461c0,.05-.4-.18-.78-.51s-.66-.66-.61-.71.4.17.78.51S194.75,461,194.7,461Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.00500082969666px 460.3898658156395px"
    },
    id: "elulrxtmzjo3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,458.92a2.51,2.51,0,0,1-1.15.17,2.71,2.71,0,0,1-1.15-.11,2.59,2.59,0,0,1,1.15-.16A2.62,2.62,0,0,1,195.8,458.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.6500244140625px 458.95269310474396px"
    },
    id: "elsbqoadzyxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.17,457.45a3.25,3.25,0,0,1-2.61.23,7.81,7.81,0,0,1,1.31-.1A7.71,7.71,0,0,1,196.17,457.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.86500549316406px 457.6511436700821px"
    },
    id: "elxquivxd903",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.16,460.07a4.21,4.21,0,0,1-1.42,0,8.64,8.64,0,0,1-1.51-.31,4.58,4.58,0,0,1-.86-.35A.78.78,0,0,1,188,459a.56.56,0,0,1,.21-.57,2.6,2.6,0,0,1,3.22.72,2.47,2.47,0,0,1,.47.94c.06.24.06.37,0,.38a3.9,3.9,0,0,0-.66-1.2,2.5,2.5,0,0,0-1.22-.77,2.19,2.19,0,0,0-1.68.14c-.22.16-.13.43.12.57a3.74,3.74,0,0,0,.8.33,9.62,9.62,0,0,0,1.46.36C191.62,460,192.16,460,192.16,460.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.07323598861694px 459.3104758262634px"
    },
    id: "el9g6j9e0g74i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.79,460.15a1.43,1.43,0,0,1-.17-1,2.3,2.3,0,0,1,.37-1,1.42,1.42,0,0,1,1.17-.74.56.56,0,0,1,.44.65,1.48,1.48,0,0,1-.23.63,4.29,4.29,0,0,1-.66.87c-.44.44-.78.61-.8.58s.28-.26.66-.71a4.75,4.75,0,0,0,.58-.86c.19-.3.32-.83,0-.89s-.72.32-.93.61a2.31,2.31,0,0,0-.39.92A5.64,5.64,0,0,0,191.79,460.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "192.6011861562729px 458.7799987792969px"
    },
    id: "els16ag5788zg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,458.36c0,.05-.63-.05-1.63.08a6.85,6.85,0,0,0-5.7,4.66c-.33.95-.35,1.59-.4,1.58a1.09,1.09,0,0,1,0-.44,6,6,0,0,1,.23-1.19,6.7,6.7,0,0,1,5.86-4.8,5.73,5.73,0,0,1,1.21,0A1.09,1.09,0,0,1,215.59,458.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.71378231048584px 461.44900012016296px"
    },
    id: "elepus9sp6rca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.19,449.23a41.05,41.05,0,0,1,.25,4.52,40,40,0,0,1,0,4.52,38.22,38.22,0,0,1-.25-4.51A40.23,40.23,0,0,1,213.19,449.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.31504821777344px 453.75px"
    },
    id: "el6giunwu9czl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,462.7a18,18,0,0,1-6.43.14c0-.08,1.45,0,3.22,0S205,462.62,205,462.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "201.78500366210938px 462.87314777076244px"
    },
    id: "elhmp3f596vjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.34,462.64c.06.05-.11.3-.25.63s-.22.63-.3.62-.11-.34.05-.72S209.3,462.58,209.34,462.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.03861412405968px 463.2600487470627px"
    },
    id: "ele9qss9w21lu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.94,460.59c.06.05-.08.28-.31.52s-.45.38-.5.33.09-.28.31-.52S210.89,460.54,210.94,460.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "210.5368873476982px 461.0149981379509px"
    },
    id: "eld8kmtf2tvfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.26,459.64c0,.07-.31.08-.63.19s-.55.3-.61.25.12-.36.52-.5S213.28,459.57,213.26,459.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.63476479053497px 459.8029797077179px"
    },
    id: "elvfj0ppem3zo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.91,459.18c0,.07-.1.19-.28.26s-.35.07-.38,0,.1-.19.28-.26S214.88,459.11,214.91,459.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.57784041762352px 459.3100128173828px"
    },
    id: "elppvzcyxw07p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.28,459.76l.07-11.74-22-.27-.28,17.19,1.37.1c6.06.41,30.88,1.66,34.95.48C299.92,464.2,281.28,459.76,281.28,459.76Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "277.58482551574707px 456.8822021484375px"
    },
    id: "elrfd0b7wcqnq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ely23567sns8m"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "263.02500915527344px 461.6590995788574px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267,464.86a7.65,7.65,0,0,0-2.75-4.73,7.45,7.45,0,0,0-5.12-1.66l-.08,6.15Z",
    id: "el0yo4tn9nas7h",
    style: {
      transformOrigin: "263.02500915527344px 461.6590995788574px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el6btr39cngnq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "277.6164722442627px 464.0738296508789px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.38,462.26s6.53,2,5.7,3-25.95.75-37-.36l0-.5,29.3.63S289.1,462.3,290.38,462.26Z",
    id: "elhhc3atz3dw",
    style: {
      transformOrigin: "277.6164722442627px 464.0738296508789px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M258.76,464.43l.38,0,1.08.08,4,.23c3.37.16,8,.32,13.2.4s9.83,0,13.21-.05l4-.11,1.09,0,.38,0a1.67,1.67,0,0,0-.38,0h-1.09l-4,0c-3.38,0-8.05,0-13.21,0s-9.82-.21-13.19-.32l-4-.14-1.09,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "277.4300079345703px 464.80195501446724px"
    },
    id: "elfj7lq348kqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.39,465.41a9.29,9.29,0,0,1,.77-1.9,8.12,8.12,0,0,1,1.39-1.51,2.88,2.88,0,0,0-1.61,1.37A3,3,0,0,0,288.39,465.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "289.46302139759064px 463.7050018310547px"
    },
    id: "elraelvw7g9kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.94,462c.06,0,.38-.33.71-.83s.54-.94.48-1-.38.33-.71.83S281.88,462,281.94,462Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "282.534994661808px 461.08195543289185px"
    },
    id: "elu8q52eeibkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.17,461.07c.05.05.4-.17.79-.51s.65-.65.6-.71-.4.17-.78.51S280.12,461,280.17,461.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.86518907546997px 460.4587772488594px"
    },
    id: "elzss21cwsg1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,459a2.76,2.76,0,0,0,1.15.16,2.53,2.53,0,0,0,1.15-.11,2.74,2.74,0,0,0-1.14-.16A2.59,2.59,0,0,0,279.07,459Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.21998596191406px 459.0251734703779px"
    },
    id: "el4kt41une112",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.71,457.51a3.22,3.22,0,0,0,2.6.23,7,7,0,0,0-1.3-.11A6.29,6.29,0,0,0,278.71,457.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.00999450683594px 457.7111715525389px"
    },
    id: "eluzk5714diie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71,460.12a3.91,3.91,0,0,0,1.42,0,7.8,7.8,0,0,0,1.51-.31,5.27,5.27,0,0,0,.86-.34.84.84,0,0,0,.36-.44.56.56,0,0,0-.21-.57,2.6,2.6,0,0,0-3.21.72,2.38,2.38,0,0,0-.48.94.85.85,0,0,0,0,.38,3.9,3.9,0,0,1,.66-1.2,2.57,2.57,0,0,1,1.22-.77,2.19,2.19,0,0,1,1.68.14c.22.17.13.43-.12.58a4,4,0,0,1-.8.32,9.19,9.19,0,0,1-1.46.37C283.25,460.08,282.71,460.08,282.71,460.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "284.7917549610138px 459.3422554731369px"
    },
    id: "els62bi3k471p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.08,460.2a1.43,1.43,0,0,0,.17-1,2.34,2.34,0,0,0-.37-1,1.42,1.42,0,0,0-1.17-.74.57.57,0,0,0-.44.65,1.57,1.57,0,0,0,.23.64,4.49,4.49,0,0,0,.66.86c.44.44.78.61.8.58s-.28-.25-.66-.71a4.64,4.64,0,0,1-.58-.85c-.19-.3-.32-.84,0-.9s.71.32.92.61a2.31,2.31,0,0,1,.39.92A5.6,5.6,0,0,1,283.08,460.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "282.26955211162567px 458.8299865722656px"
    },
    id: "el646apep5f2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.28,458.41s.64-.05,1.63.08a6.88,6.88,0,0,1,5.7,4.67c.33.94.35,1.58.4,1.57a1.09,1.09,0,0,0,0-.44,5.38,5.38,0,0,0-.23-1.19,6.82,6.82,0,0,0-2.18-3.31,6.9,6.9,0,0,0-3.68-1.49,5.73,5.73,0,0,0-1.21,0A1.8,1.8,0,0,0,259.28,458.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.1562194824219px 461.4990713596344px"
    },
    id: "el2jwuzapxd2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.68,449.28a41.28,41.28,0,0,0-.25,4.52,40.31,40.31,0,0,0,0,4.53,38.29,38.29,0,0,0,.25-4.52A40.31,40.31,0,0,0,261.68,449.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "261.5549831390381px 453.8050079345703px"
    },
    id: "elt2a1evq20in",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.84,462.75a18,18,0,0,0,6.43.14c0-.07-1.45,0-3.22-.05S269.85,462.67,269.84,462.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "273.05499267578125px 462.91851027309895px"
    },
    id: "eltdkb6rktm3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.53,462.69c-.06.05.11.3.25.64s.22.62.3.62.12-.35-.05-.73S265.57,462.64,265.53,462.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.833189278841px 463.3162233233452px"
    },
    id: "el2rgkdfdzx9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.93,460.65c-.06.05.08.28.31.51s.45.38.5.33-.09-.28-.31-.51S264,460.59,263.93,460.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.3331196010113px 461.06845331192017px"
    },
    id: "elu23znges1bg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.61,459.69c0,.08.31.08.63.2s.55.29.61.24-.12-.36-.52-.5S261.59,459.62,261.61,459.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.2352204322815px 459.85334676504135px"
    },
    id: "elpar4nnx0z3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,459.23c0,.07.1.19.28.26s.35.08.38,0-.1-.18-.28-.26S260,459.17,260,459.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.3321586549282px 459.36179146170616px"
    },
    id: "elnan07388pf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.79 245.32 283.78 456.99 256.31 457.64 258.47 274.11 217.36 457.99 193.97 456.93 230.65 245.75 293.79 245.32",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.8800048828125px 351.6549987792969px"
    },
    id: "el9nklap0cmvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.21,248.18a23.42,23.42,0,0,1-.25,3.48c-.23,2.14-.58,5.09-1,8.35a34.22,34.22,0,0,1-.76,4.6,6.48,6.48,0,0,1-2,3.29,5,5,0,0,1-2.33,1.15,2,2,0,0,1-.95,0,5.92,5.92,0,0,0,4.79-4.6,40.69,40.69,0,0,0,.7-4.54c.43-3.25.84-6.2,1.17-8.32A20.2,20.2,0,0,1,265.21,248.18Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "261.565034866333px 258.6436004638672px"
    },
    id: "elyf2gn803ks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.44,249.44c.08.05-.18.4,0,.95a1.09,1.09,0,0,0,.57.68.93.93,0,0,0,1-.23.91.91,0,0,0,.28-1,1.14,1.14,0,0,0-.65-.61c-.54-.21-.9,0-.95-.05s.29-.49,1.06-.35a1.49,1.49,0,0,1,1,.8,1.49,1.49,0,0,1-2,1.87,1.43,1.43,0,0,1-.74-1.08C257.94,249.7,258.42,249.37,258.44,249.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "259.42070257663727px 250.21401739120483px"
    },
    id: "eluy3hyps0cv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,253.09a6.15,6.15,0,0,1,.41-5.86c.16.06-.27,1.32-.37,2.91S241.17,253,241,253.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "240.94519340991974px 250.1599884033203px"
    },
    id: "elmhllr1rxlst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.92,252.69a7.18,7.18,0,0,1,.2-6.1,25.29,25.29,0,0,1-.2,3A26.11,26.11,0,0,1,244.92,252.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "244.72787576913834px 249.64000701904297px"
    },
    id: "el7fmd5h7ipdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.73,252.3a19.61,19.61,0,0,1,.07-3.16,20,20,0,0,1,0-3.17,8.58,8.58,0,0,1-.09,6.33Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "279.02873638272285px 249.13500213623047px"
    },
    id: "elvx8zlgnlsq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,251.91c-.16-.06.3-1.45.35-3.22s-.3-3.19-.14-3.24a5,5,0,0,1,.71,3.25A5.1,5.1,0,0,1,283,251.91Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "283.46239814162254px 248.68000030517578px"
    },
    id: "elhxc0necy11w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.65 149.72 246.65 149.72 246.65 149.72 246.65 149.72",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "246.64999389648438px 149.72000122070312px"
    },
    id: "elaxuqyclw0nv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.71,112.6c1.12-1.33,2-3.7,1.31-5.3,1.34-.69,1.46-1.88,1.46-3.38a9.21,9.21,0,0,0-1.3-4.27,12.38,12.38,0,0,0-4.83-5.29,6.43,6.43,0,0,0-6.87.3,8.33,8.33,0,0,0-11.93-.84,8.84,8.84,0,0,1-1.81,1.65c-1.19.66-2.65.41-4,.54a7,7,0,0,0-5.82,9.76,7.62,7.62,0,0,0-3.23,5.83,22.32,22.32,0,0,0,.78,6.83c.62,2.77,1.32,5.68,3.28,7.73a8.05,8.05,0,0,0,5.14,2.43,8.2,8.2,0,0,0,7.2-3.39",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "259.5756664276123px 110.15158081054688px"
    },
    id: "elkqrjn3cddcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.44,159.79l22.22-1c.13-2.36-1.08-17-1.08-17s8.4-1.3,8.51-9.7-1.36-27.68-1.36-27.68h0a29.2,29.2,0,0,0-29.33,3.68l-1.24,1Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "261.1279706954956px 130.9135036468506px"
    },
    id: "ely57wpgdndz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.6,141.7a19.55,19.55,0,0,1-11-3.11s2.59,6,11,5.29Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "263.1000061035156px 141.26418590545654px"
    },
    id: "elywqz9g2ilp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.19,117.78c-.14-.06-5.77-1.71-5.58,4s5.91,4.38,5.91,4.21S246.19,117.78,246.19,117.78Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "243.5626540184021px 121.8785572052002px"
    },
    id: "elcf82pu8gw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.7,123.9s-.1.08-.27.16a1,1,0,0,1-.74,0,2.46,2.46,0,0,1-1.22-2.19,3.22,3.22,0,0,1,.24-1.44,1.17,1.17,0,0,1,.72-.79.51.51,0,0,1,.6.26c.08.16.05.27.08.28s.12-.1.07-.34a.67.67,0,0,0-.24-.35.74.74,0,0,0-.56-.13,1.42,1.42,0,0,0-1,.93,3.36,3.36,0,0,0-.3,1.61,2.6,2.6,0,0,0,1.54,2.43,1.08,1.08,0,0,0,.91-.18C244.69,124,244.72,123.91,244.7,123.9Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "243.38951635360718px 121.85623526573181px"
    },
    id: "elghxmg8mwze7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.88,117.6a1.19,1.19,0,0,1-1.15,1.21,1.15,1.15,0,0,1-1.24-1.08,1.2,1.2,0,0,1,1.15-1.21A1.14,1.14,0,0,1,273.88,117.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.6850687265396px 117.66457426548004px"
    },
    id: "el4ilz7f4ldfv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,116.25c-.14.16-1.05-.52-2.34-.51s-2.24.65-2.38.49.08-.35.49-.65a3.33,3.33,0,0,1,1.91-.59,3.17,3.17,0,0,1,1.87.6C274.08,115.9,274.22,116.18,274.14,116.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "271.769748210907px 115.63217097520828px"
    },
    id: "el5tu6y7aup7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.24,117.9a1.19,1.19,0,0,1-1.15,1.21,1.15,1.15,0,0,1-1.24-1.08,1.2,1.2,0,0,1,1.16-1.21A1.14,1.14,0,0,1,261.24,117.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.0450530052185px 117.96500933170319px"
    },
    id: "elvv098s9c8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.46,116.49c-.15.16-1.06-.52-2.35-.51s-2.24.65-2.38.49.08-.35.5-.65a3.29,3.29,0,0,1,1.9-.59,3.17,3.17,0,0,1,1.87.6C261.4,116.14,261.53,116.42,261.46,116.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "259.0829312801361px 115.87216466665268px"
    },
    id: "eltxyyk22o9hs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,126.06a9.08,9.08,0,0,1,2.1-.38c.33,0,.64-.1.7-.32a1.85,1.85,0,0,0-.22-1l-1-2.51a44.34,44.34,0,0,1-2.19-6.56,42.47,42.47,0,0,1,2.71,6.37l.94,2.53a1.91,1.91,0,0,1,.17,1.29.83.83,0,0,1-.54.48,2,2,0,0,1-.56.08A8,8,0,0,1,266.14,126.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.4623136520386px 120.7051157951355px"
    },
    id: "el2b1ptj6ln5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34,127c.21,0,.22,1.39,1.42,2.39s2.69.84,2.7,1-.34.28-1,.29a3.47,3.47,0,0,1-2.25-.78,3.08,3.08,0,0,1-1.1-2C262.09,127.29,262.25,127,262.34,127Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.2842719554901px 128.84023368358612px"
    },
    id: "ele06mwf9myip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,111.43c-.13.35-1.41.19-2.93.37s-2.74.6-2.94.28c-.09-.15.12-.48.62-.82a4.89,4.89,0,0,1,2.18-.76,4.81,4.81,0,0,1,2.29.27C261.57,111,261.85,111.27,261.79,111.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "258.84886479377747px 111.32970404624939px"
    },
    id: "elfx8mk9fspji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.67,112.51c-.23.3-1.12,0-2.19,0s-2,.2-2.18-.11c-.09-.15.05-.44.45-.72a3.16,3.16,0,0,1,3.52.11C273.65,112.07,273.77,112.37,273.67,112.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "271.48873949050903px 111.9204934835434px"
    },
    id: "eleldl4e0yld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.71,108.7c.11,2.44-.43,5.17,0,7.57.07.37,1,1.34,1.1,1.7.49,2.12,1.37,3,2.64.84a19.07,19.07,0,0,0,1-4.14l1.53-7.76a13.43,13.43,0,0,0,6.39,1.52,6.54,6.54,0,0,0,5.45-3.22,6.78,6.78,0,0,0,10.51,1.38,2.83,2.83,0,0,0,3.74.79,3.36,3.36,0,0,0,1.37-3.7c-.58-2.05-2.78-3.16-4.82-3.76-8-2.35-16.82-.51-24,3.7a12.23,12.23,0,0,0-2.9,2.19c-.82.89-1.95,2-2,3.16",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "261.55286979675293px 109.47261238098145px"
    },
    id: "elvg3g37ha6rj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.73,122.5s.3-.36.7-1.07a5.24,5.24,0,0,0,.6-3.3,5,5,0,1,0-5.66,5.66,5.25,5.25,0,0,0,3.3-.59c.71-.4,1-.74,1.06-.7s-.06.1-.21.26a4.24,4.24,0,0,1-.75.61,5.18,5.18,0,0,1-3.45.79,5.44,5.44,0,1,1,6.07-6.07,5.16,5.16,0,0,1-.78,3.44,4,4,0,0,1-.61.76Q263.76,122.51,263.73,122.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "259.9911890029907px 118.76053142547607px"
    },
    id: "el5fz8ai40i6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,122.5s.3-.36.7-1.07a5.25,5.25,0,0,0,.59-3.3,5,5,0,1,0-5.66,5.66,5.25,5.25,0,0,0,3.3-.59c.71-.4,1-.74,1.07-.7s-.06.1-.21.26a4,4,0,0,1-.76.61,5.17,5.17,0,0,1-3.44.79,5.44,5.44,0,1,1,6.06-6.07,5.16,5.16,0,0,1-.78,3.44,4,4,0,0,1-.61.76C277.12,122.44,277,122.51,277,122.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "273.2511124610901px 118.75955724716187px"
    },
    id: "el6rzrhug4kvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.21,118.4c0,.15-.66.26-1.48.26s-1.49-.11-1.49-.26.67-.26,1.49-.26S268.21,118.26,268.21,118.4Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "266.72499084472656px 118.4000015258789px"
    },
    id: "elvm7spb1hj5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,118a20,20,0,0,1,4.57-.42,20.86,20.86,0,0,1,4.59.11,19.71,19.71,0,0,1-4.57.41A20.53,20.53,0,0,1,245.8,118Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "250.37999725341797px 117.84296315908432px"
    },
    id: "el9rm8v40vbdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.62,116.39l-7.18-2.59-6.8,2.36L227.23,126l-6.12,5.84,10,4.44,5.29-2.11,8.43-5.74,4.77-9s-1.36-.64-2.89,1.51l-1.43,1.91-1.36-5.2,0-1.54,4.22,1.29a2.22,2.22,0,0,0,2.4-.7Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "235.86499786376953px 125.04000091552734px"
    },
    id: "elkb4acxuems",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.15,124c.06,0,.35.38.62,1.14a8,8,0,0,1-.39,6.13c-.37.72-.71,1.09-.76,1.05a17.22,17.22,0,0,0,1-4.11A16.82,16.82,0,0,0,237.15,124Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "237.41144961118698px 128.16146993637085px"
    },
    id: "elw8rt16lmk58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.22,124.1a13.65,13.65,0,0,1,2.61-.62h0l.06,0a.93.93,0,0,1,.43,1,2.91,2.91,0,0,1-.45,1,1.07,1.07,0,0,0-.18.91,2.1,2.1,0,0,0,.71.84h-.31a5.77,5.77,0,0,0,1.82-1.76c.7-1.11-.1-2.28-.53-3.35a4,4,0,0,0-.35-.69.64.64,0,0,0-.56-.12l-1.42.22a16,16,0,0,1-2.84.32,15.25,15.25,0,0,1,2.78-.68l1.42-.28a1.06,1.06,0,0,1,.95.22,3.17,3.17,0,0,1,.45.81c.24.54.53,1.06.75,1.7a2.55,2.55,0,0,1-.19,2.1,6.13,6.13,0,0,1-2,1.92l-.16.11-.15-.13a2.56,2.56,0,0,1-.83-1.07,1.49,1.49,0,0,1,.25-1.28,2.68,2.68,0,0,0,.43-.87.6.6,0,0,0-.19-.64l.11,0A14.14,14.14,0,0,1,237.22,124.1Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "239.45631980895996px 124.30345702171326px"
    },
    id: "elkgy09o79pg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.53,124.86s.12.21.46.32a.88.88,0,0,0,1.12-.62,3,3,0,0,0-.42-2.22c-.36-.84-.73-1.84-1.16-2.75s-1.54-.76-2.44-.66-1.74.21-2.43.32a13.72,13.72,0,0,1-2.25.33,7.89,7.89,0,0,1,2.18-.69c.69-.16,1.52-.32,2.45-.44a6.63,6.63,0,0,1,1.51-.08,1.76,1.76,0,0,1,1.43,1c.49,1,.8,2,1.16,2.82a7.76,7.76,0,0,1,.42,1.29,2,2,0,0,1-.11,1.24,1.24,1.24,0,0,1-.75.74,1,1,0,0,1-.79-.06C242.51,125.16,242.51,124.85,242.53,124.86Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "240.0108642578125px 121.93597078323364px"
    },
    id: "eli8w8vl8ymes",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,122.84a7.89,7.89,0,0,1-.69-1.92c-.19-.66-.4-1.37-.61-2.11-.12-.39-.23-.84-.35-1.23a1.38,1.38,0,0,0-.79-.83,4.19,4.19,0,0,0-2.46.24l-2.13.57a8.22,8.22,0,0,1-2,.39,8,8,0,0,1,1.9-.75l2.09-.67a4.37,4.37,0,0,1,2.8-.26,1.88,1.88,0,0,1,1.07,1.14c.14.47.22.87.33,1.28l.51,2.14A7.8,7.8,0,0,1,245.32,122.84Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "240.80500030517578px 119.49494576454163px"
    },
    id: "el8beejmmwluf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.23,126a1.22,1.22,0,0,1,.15-.19c.14-.14.29-.32.48-.53l1.87-2,6.82-7.21,0,0h0l6.8-2.39,0,0,.05,0,7.19,2.58.1,0v.47l0,0a2.29,2.29,0,0,1-1.14.76,3.19,3.19,0,0,1-1.41,0h0l-2.95-.9-1.26-.39.2-.14c0,.51,0,1,0,1.54v-.05c.46,1.78.92,3.52,1.36,5.2l-.27,0c.62-.82,1.19-1.62,1.82-2.4a2.59,2.59,0,0,1,2.68-1.06l.14,0-.08.15-4.79,9v0h0l-6.2,4.16L237,133.79c-.39.26-.6.38-.6.38s.19-.16.56-.43l1.67-1.16,6.14-4.24,0,0,4.74-9,.07.2a1.65,1.65,0,0,0-1.26.12,3.7,3.7,0,0,0-1.08.87c-.59.74-1.18,1.58-1.79,2.39l-.19.25-.08-.3c-.45-1.69-.9-3.42-1.37-5.2v0c0-.51,0-1,0-1.54v-.21l.2.06,1.26.39,2.95.9h0a2.87,2.87,0,0,0,1.27,0,2,2,0,0,0,1-.66l0,.1v-.3l.1.14-7.18-2.6h.1l-6.81,2.35,0,0-6.9,7.13-1.91,2-.51.51A.87.87,0,0,1,227.23,126Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "238.95999908447266px 123.92499923706055px"
    },
    id: "el3n714hdh4x4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.15,189.3l-.47-34.55,9-3c2.83-.54,5.58-1.57,8.91-1.71h0a17.54,17.54,0,0,0,21.41.27l.3-.23c.86.1,2,.21,3.43.38l.28,0a21,21,0,0,1,9.83,3.92v0l44.72,26.7,26.26-20,13.3,10.43s-34.4,34.4-37.74,35.22c-2.31.57-25.26-12-39.17-19.72.57,8.33,3.68,54.63,3.53,61h-63.9l-.05-29.2,0-7.95Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "298.3999786376953px 199.0250015258789px"
    },
    id: "elbp63kpkv3uc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.35,167.26a6.7,6.7,0,0,0-.05,1.54c0,1.11.08,2.51.12,4.16.13,3.52.36,8.37.65,13.73s.58,10.21.83,13.72c.13,1.65.24,3,.32,4.15a8.16,8.16,0,0,0,.21,1.53,6.63,6.63,0,0,0,.05-1.53c0-1.12-.08-2.51-.13-4.17-.13-3.52-.35-8.37-.64-13.73s-.58-10.22-.83-13.73c-.13-1.65-.24-3-.33-4.15A7.74,7.74,0,0,0,289.35,167.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "290.389945268631px 186.67498016357422px"
    },
    id: "elyh9mz1c02w9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.79,166.8c-.15.16,2.74,2.89,6.43,6.11s6.77,5.72,6.89,5.58-2.78-2.84-6.47-6.07c-1.84-1.61-3.53-3-4.77-4.06A13.91,13.91,0,0,0,346.79,166.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.44901752471924px 172.6478066444397px"
    },
    id: "ely9rq0j5pzp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.74,169.08c-.12.14,2.81,2.88,6.51,6.16,1.85,1.64,3.55,3.09,4.8,4.12a10.81,10.81,0,0,0,2.12,1.57,10.74,10.74,0,0,0-1.81-1.91c-1.18-1.12-2.83-2.63-4.69-4.27s-3.55-3.09-4.81-4.11A10.45,10.45,0,0,0,343.74,169.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "350.4532103538513px 175.00502014160156px"
    },
    id: "elg3wcr5ecu3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.13,126.11S197.57,150,189.5,159.79c-3.65,4.41-4.48,11-1.54,15.9h0a12.14,12.14,0,0,0,11.26,5.9L230,179.53l2.33-25.61-18.61,5.81,21.68-22.67Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "210.78975296020508px 153.86423110961914px"
    },
    id: "ely9xv8ekghlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.82,199.8c-.15,0-.19-5.5-.1-12.27s.28-12.25.43-12.25.18,5.49.09,12.26S230,199.8,229.82,199.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "229.98151025176048px 187.54000091552734px"
    },
    id: "el06d8mkzcn4iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.15,150.92a6.06,6.06,0,0,1-.77,1l-2.26,2.53c-1.93,2.13-4.66,5.09-7.78,8.44l.06-.11c-.3,1.08-.67,2.19-1.09,3.3a32.25,32.25,0,0,1-3.39,6.86,15.69,15.69,0,0,1-4.53,4.31,11,11,0,0,1-3.92,1.57,6.46,6.46,0,0,1-1.14.12c-.26,0-.4,0-.4,0s.55-.08,1.5-.31a12,12,0,0,0,3.76-1.68,16,16,0,0,0,4.33-4.27,34.12,34.12,0,0,0,3.31-6.77c.41-1.1.77-2.2,1.08-3.26l0-.06,0,0c3.13-3.34,5.91-6.25,7.91-8.32l2.36-2.42A7.39,7.39,0,0,1,222.15,150.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.54000091552734px 164.92999267578125px"
    },
    id: "el5pda9kkmjiv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.85,166.71a12.06,12.06,0,0,1-1.15,9.42c-.15-.06.72-2,1-4.66S209.69,166.73,209.85,166.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.50609385967255px 171.42000579833984px"
    },
    id: "elk5wwfzlf12k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.09,247.37a1.16,1.16,0,0,1-.14-.2l-.39-.62-1.44-2.4a41.5,41.5,0,0,1-2.13-3.9,9.52,9.52,0,0,1-.9-5.81c.41-2.2,1.72-4.28,2.68-6.61a10.74,10.74,0,0,0,.83-3.77,17.15,17.15,0,0,0-.43-4.11c-.58-2.79-1.67-5.66-1.95-8.83a31.48,31.48,0,0,1,.86-9.69c.73-3.25,1.63-6.37,2.27-9.42a45.45,45.45,0,0,0,.7-4.52c0-.74.1-1.48.13-2.21s0-1.46,0-2.17a81.3,81.3,0,0,0-2.51-15c-1-4.23-1.71-7.69-2-10.11-.17-1.21-.26-2.15-.3-2.79,0-.29,0-.53,0-.73a1,1,0,0,1,0-.25s0,.09.05.25.06.43.1.72c.06.64.19,1.57.39,2.77.38,2.4,1.14,5.83,2.19,10.05a78.68,78.68,0,0,1,2.63,15.07c0,.72,0,1.46,0,2.2s-.07,1.49-.11,2.25c-.15,1.51-.39,3-.7,4.58-.64,3.08-1.54,6.19-2.26,9.42a31.21,31.21,0,0,0-.86,9.53c.26,3.09,1.33,5.94,1.91,8.78a17,17,0,0,1,.41,4.23,11,11,0,0,1-.88,3.91c-1,2.38-2.31,4.41-2.71,6.52a9.18,9.18,0,0,0,.8,5.62,42.85,42.85,0,0,0,2,3.92l1.35,2.45.34.64C239.07,247.29,239.1,247.37,239.09,247.37Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "236.84901237487793px 200.8000030517578px"
    },
    id: "elslnjxq945zj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,153.91a1,1,0,0,1,.07.24l.16.71c.13.62.3,1.54.5,2.74a70.93,70.93,0,0,1,.87,10.21,75.73,75.73,0,0,1-1.31,15.13c-1,5.63-2.66,11.72-3.2,18.27s.46,12.81,1.24,18.46a118.72,118.72,0,0,1,1.51,15.12,35.79,35.79,0,0,1-1.2,10.16l-.22.83-.25.71-.42,1.11-.26.67c-.06.15-.1.23-.1.23a.88.88,0,0,1,0-.25l.22-.69.36-1.12c.07-.22.15-.45.23-.71s.12-.54.19-.83a37.27,37.27,0,0,0,1-10.11,124.25,124.25,0,0,0-1.63-15c-.8-5.65-1.77-11.93-1.28-18.57s2.22-12.71,3.25-18.31a77.16,77.16,0,0,0,1.41-15.05,80.92,80.92,0,0,0-.7-10.18c-.16-1.2-.3-2.13-.41-2.75,0-.29-.08-.53-.1-.72A.6.6,0,0,1,253,153.91Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "251.97755813598633px 201.20502471923828px"
    },
    id: "elkx5hu4tljqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.49,247.41l-.14-.21-.37-.64a6,6,0,0,1-.51-1.1c-.08-.22-.19-.46-.27-.73s-.14-.55-.22-.85a15.89,15.89,0,0,1-.32-4.51,53.43,53.43,0,0,1,.79-5.94,51.16,51.16,0,0,0,.89-7.14,21.49,21.49,0,0,0-1.41-8,65.82,65.82,0,0,1-2.78-8.77,28.89,28.89,0,0,1,.19-9.89c.52-3.35,1.2-6.57,1.39-9.73a37.3,37.3,0,0,0-.71-9.06c-1.12-5.72-2.67-10.79-3.2-15.22a28.41,28.41,0,0,1,.32-10.46,14.39,14.39,0,0,1,1.32-3.62.86.86,0,0,1-.08.25l-.26.69a21,21,0,0,0-.78,2.72,28.85,28.85,0,0,0-.15,10.37c.56,4.38,2.15,9.42,3.3,15.18a37.08,37.08,0,0,1,.75,9.18c-.18,3.21-.87,6.46-1.39,9.78a28.65,28.65,0,0,0-.2,9.71,66.16,66.16,0,0,0,2.73,8.71,29.89,29.89,0,0,1,1.12,4.16,18.17,18.17,0,0,1,.27,4.06,49.27,49.27,0,0,1-1,7.2,54.65,54.65,0,0,0-.86,5.88,16.25,16.25,0,0,0,.23,4.46A15.54,15.54,0,0,0,276.49,247.41Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "273.1349985599518px 199.47500610351562px"
    },
    id: "elue86pzn26is",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.94,157.56a1.33,1.33,0,0,1,.08.23l.19.67c.18.59.37,1.47.59,2.62a43,43,0,0,1,.39,9.86c-.24,4.16-1.05,9.07-1.8,14.51a130.3,130.3,0,0,0-1.11,17.81,241.25,241.25,0,0,0,2.88,32.32c.61,4.08,1.11,7.4,1.46,9.75.17,1.11.29,2,.39,2.65,0,.28.06.5.09.69a1.08,1.08,0,0,1,0,.24,1,1,0,0,1-.07-.23c0-.19-.08-.41-.13-.69-.12-.64-.28-1.52-.49-2.63-.4-2.29-1-5.61-1.62-9.72a224.49,224.49,0,0,1-3-32.38,126.4,126.4,0,0,1,1.16-17.88c.78-5.45,1.61-10.33,1.9-14.47a44.9,44.9,0,0,0-.22-9.8c-.18-1.14-.34-2-.49-2.63l-.14-.68A.71.71,0,0,1,284.94,157.56Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "285.4471769332886px 203.23500061035156px"
    },
    id: "ely9o13pc5kxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.34,193.31a3.75,3.75,0,0,1-.15-1c-.06-.66-.13-1.62-.19-2.81-.13-2.37-.24-5.65-.25-9.28s.06-6.91.17-9.28c.06-1.19.11-2.15.17-2.81a4.45,4.45,0,0,1,.13-1,3.81,3.81,0,0,1,.07,1v2.81c0,2.5,0,5.72,0,9.27s.07,6.77.1,9.27c0,1.09,0,2,0,2.81A4.56,4.56,0,0,1,300.34,193.31Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "300.0740986466408px 180.22000122070312px"
    },
    id: "elnycr1bxt9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,170.79a7.24,7.24,0,0,1-.46.91,5.8,5.8,0,0,0-.58,2.64c0,1.15.24,2.55.4,4.09s.53,3.22.76,5a23.25,23.25,0,0,1,.1,5.11,12.79,12.79,0,0,1-1,4.08,10.68,10.68,0,0,1-1.47,2.4c-.42.52-.69.77-.72.75a22.81,22.81,0,0,0,1.85-3.29,19.23,19.23,0,0,0,.7-9c-.22-1.77-.55-3.46-.72-5a37.21,37.21,0,0,1-.29-4.16,5.55,5.55,0,0,1,.77-2.73A2.75,2.75,0,0,1,310,170.79Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "308.67268455028534px 183.2805471420288px"
    },
    id: "el92q2l9friea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.28,179.93a7.88,7.88,0,0,1,1.34,0,14.45,14.45,0,0,0,3.57-.33,8.68,8.68,0,0,0,4.32-2.88c1.33-1.51,2.66-3.32,4.13-5.14,2.92-3.68,5.58-7,7.53-9.36l2.32-2.8a6.82,6.82,0,0,1,.91-1,6.61,6.61,0,0,1-.75,1.1l-2.19,2.91c-1.88,2.43-4.49,5.78-7.41,9.45-1.48,1.83-2.8,3.61-4.18,5.14a8.89,8.89,0,0,1-4.59,2.92,12.38,12.38,0,0,1-3.67.17A5.85,5.85,0,0,1,202.28,179.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "214.3400115966797px 169.29756927490234px"
    },
    id: "elmmqa65j63j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.68,132.09a3.8,3.8,0,0,1-.24.59,11.72,11.72,0,0,1-.86,1.6,20,20,0,0,1-4.44,5c-2.15,1.83-5,3.67-7.95,5.85s-6.15,4.85-8.07,8.65a53.06,53.06,0,0,1-2.94,5.55,15.85,15.85,0,0,1-4.24,4.07c-1.54,1.07-3.06,2-4.39,2.91a16.06,16.06,0,0,0-3.36,3,7.84,7.84,0,0,0-1.86,6.06,6.72,6.72,0,0,0,.83,2.25s0,0-.11-.12a1.89,1.89,0,0,1-.28-.39,5.21,5.21,0,0,1-.64-1.7,8,8,0,0,1,1.77-6.33,16.17,16.17,0,0,1,3.4-3.14c1.34-1,2.86-1.89,4.36-2.95a15.59,15.59,0,0,0,4.1-4,50.65,50.65,0,0,0,2.89-5.5c2-3.91,5.26-6.65,8.26-8.8s5.84-4,8-5.74a21,21,0,0,0,4.5-4.79,12.71,12.71,0,0,0,.93-1.54A2.69,2.69,0,0,1,227.68,132.09Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "208.35964012145996px 154.8550033569336px"
    },
    id: "el6gpleveomro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elat9331hk3j5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      transformOrigin: "205.4499969482422px 170.3842658996582px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.45,178.76a15.76,15.76,0,0,0,16-15.68c0-.53-.09-1.16-.56-1.4a1.06,1.06,0,0,0-1.25.43,3.32,3.32,0,0,0-.45,1.35,22,22,0,0,1-12.44,15.69",
    id: "eldrtzpej6774",
    style: {
      transformOrigin: "205.4499969482422px 170.3842658996582px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ellijya0bgn1g"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      transformOrigin: "313.9850158691406px 187.71222019195557px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.38,178a5.46,5.46,0,0,0-1.56,2c-2.17,3.42-6.46,4.8-9.33,7.65-2.19,2.19-3.94,4.78-3.95,7.88l4.69,2.13,12.2-19C322.32,177.79,321.11,177.52,320.38,178Z",
    id: "eldl0ch5yf8q",
    style: {
      transformOrigin: "313.9850158691406px 187.71222019195557px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M101,414.46S84.56,418,93.09,438s3.43,25.45-2.46,26.86l45.1-.29,4-50.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "115.17999649047852px 439.5699768066406px"
    },
    id: "elo9r1p3i90j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.8,464.84a13,13,0,0,1-8.69-3.26c-3.71-3.26-8.29-9.36-9.2-19.94C114,419.25,101,414.47,101,414.47l38.71-.17s12.57,0,13.59,19.87c1.07,20.83,29.95,32.79,47.78,30.46Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "151.0399932861328px 439.6089515686035px"
    },
    id: "eloqt4uc7uzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.42,379.86s-20.28-2.43-22.53,42.49-36.22,42.48-36.22,42.48h67.72S214.48,461.7,211.2,430c-1.37-13.3,22.49-50.11,22.49-50.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "183.18000030517578px 422.34511947631836px"
    },
    id: "elfqly3fdg0i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,384.94c-2.16,2.59-1.28,6.74.61,9.54s4.84,4.69,7.84,6.25,6.14,2.88,8.83,4.93c4.16,3.18,6.93,7.9,8.61,12.86a79.36,79.36,0,0,1,3.06,15.38s-2.22-37.27-8.77-47.61S184.26,380,180.12,384.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "193.9631757736206px 406.87066078186035px"
    },
    id: "elcojgxa56tf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.32,464.83s-20,1-22.78-22.21-5.11-61.37-18.12-62.76l41,0a14,14,0,0,1,13.06,8.88c1.78,4.58,3.59,11.35,4.71,21.21,2.37,20.83,14.17,55.14,43.73,54.84Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "242.67001342773438px 422.34811782836914px"
    },
    id: "eld4uopf478i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.78,445.71c0,.14-6,.26-13.35.26s-13.35-.12-13.35-.26,6-.26,13.35-.26S245.78,445.56,245.78,445.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "232.42999267578125px 445.7099914550781px"
    },
    id: "el0un1w2kv256i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,447.32a35.36,35.36,0,0,1-.22-3.93l.22.22-3.93,0,.26-.26h0v1c0,.35,0,.68,0,1,0,.64,0,1.26,0,1.85l-.23-.22a35.36,35.36,0,0,1,3.93.22,26.56,26.56,0,0,1-3.93.23h-.22v-.23c0-.59,0-1.21,0-1.85,0-.34,0-.67,0-1v-1h0l.26-.26,3.93,0h.23v.22A26.56,26.56,0,0,1,252.59,447.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.68000102043152px 445.26165080070496px"
    },
    id: "ela30yol87bce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.91,454.32c0,.15-6,.26-13.34.26s-13.35-.11-13.35-.26,6-.26,13.35-.26S251.91,454.18,251.91,454.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.56500244140625px 454.32000732421875px"
    },
    id: "elim00ancuxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.73,455.94a34.06,34.06,0,0,1-.23-3.93l.23.22-3.93,0,.26-.26h0v2.06q0,1,0,1.86l-.22-.23a34.06,34.06,0,0,1,3.93.23,27.93,27.93,0,0,1-3.93.22h-.23v-.23q0-.88,0-1.86V452h0c-.24.23.31-.32.26-.26l3.93,0H259V452A27.93,27.93,0,0,1,258.73,455.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "256.77458596229553px 453.92418456077576px"
    },
    id: "el23wfch9za3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.63,424c0,.14-6,.26-13.34.26s-13.35-.12-13.35-.26,6-.26,13.35-.26S240.63,423.86,240.63,424Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "227.28500366210938px 424px"
    },
    id: "elq5dzlv8yb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,425.62a33.84,33.84,0,0,1-.23-3.93l.23.23-3.93,0,.26-.26h0v2c0,.64,0,1.26,0,1.85l-.22-.22a35.59,35.59,0,0,1,3.93.22,26.73,26.73,0,0,1-3.93.23h-.23v-.23c0-.59,0-1.21,0-1.85v-2h0c-.23.23.32-.32.27-.26l3.93,0h.23v.22A27.75,27.75,0,0,1,247.45,425.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.51675128936768px 423.569242477417px"
    },
    id: "elcmfrsxjbf8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.17,412.68c0,.14-6,.26-13.35.26s-13.35-.12-13.35-.26,6-.26,13.35-.26S239.17,412.54,239.17,412.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "225.8199920654297px 412.67999267578125px"
    },
    id: "ele20958b10tm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,414.3a35.66,35.66,0,0,1-.22-3.94l.22.23-3.93,0,.26-.26h0v1c0,.35,0,.69,0,1,0,.65,0,1.26,0,1.86l-.23-.23a33.84,33.84,0,0,1,3.93.23,29.83,29.83,0,0,1-3.93.22h-.22v-.23c0-.6,0-1.21,0-1.86,0-.33,0-.67,0-1v-1h0c-.23.24.32-.31.26-.26l3.93,0h.23v.22A26.81,26.81,0,0,1,246,414.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244.06173419952393px 412.23411321640015px"
    },
    id: "elqeutvy1khh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,402.31c0,.14-6,.26-13.35.26s-13.35-.12-13.35-.26,6-.26,13.35-.26S237.23,402.16,237.23,402.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.87998962402344px 402.30999755859375px"
    },
    id: "eluhv2r4ezas",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,403.92a36.47,36.47,0,0,1-.23-3.93l.23.23-3.93,0,.26-.26h0v1c0,.35,0,.69,0,1,0,.64,0,1.26,0,1.85l-.22-.22a35.36,35.36,0,0,1,3.93.22,26.73,26.73,0,0,1-3.93.23h-.22v-.23c0-.59,0-1.21,0-1.85,0-.33,0-.67,0-1v-1h0c-.23.23.31-.32.26-.26l3.93,0h.23V400A28.46,28.46,0,0,1,244,403.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.07134413719177px 401.869261264801px"
    },
    id: "el59vxjsmwhyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,392.8c0,.14-6,.26-13.35.26s-13.35-.12-13.35-.26,6-.27,13.35-.27S234.48,392.65,234.48,392.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.12998962402344px 392.7949981689453px"
    },
    id: "eljaksnm6e9bk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.29,394.41a35.36,35.36,0,0,1-.22-3.93l.22.22-3.93,0,.26-.26h0v1.05c0,.34,0,.68,0,1,0,.64,0,1.26,0,1.85l-.23-.23a36.47,36.47,0,0,1,3.93.23,28.46,28.46,0,0,1-3.93.23h-.22v-.23c0-.59,0-1.21,0-1.85,0-.34,0-.68,0-1v-1.05h0l.26-.26,3.93,0h.23v.23A26.73,26.73,0,0,1,241.29,394.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "239.3799901008606px 392.37582302093506px"
    },
    id: "elnc9tadsmklo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,384.82c0,.14-6,.26-13.35.26s-13.35-.12-13.35-.26,6-.26,13.35-.26S229.85,384.68,229.85,384.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "216.5px 384.82000732421875px"
    },
    id: "elyvi329j9z9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.66,386.43a35.13,35.13,0,0,1-.22-3.93l.22.23-3.93,0,.26-.26h0v1c0,.35,0,.69,0,1,0,.65,0,1.26,0,1.85l-.23-.22a38.52,38.52,0,0,1,3.93.22,26.56,26.56,0,0,1-3.93.23h-.22v-.24c0-.59,0-1.2,0-1.85,0-.33,0-.67,0-1v-1h0l.26-.26,3.93,0h.23v.22A26.4,26.4,0,0,1,236.66,386.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.7500159740448px 384.3766415119171px"
    },
    id: "el075oia443g1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.16,405.2a9.73,9.73,0,0,1,1.8-2.61c.23-.26.44-.52.67-.79l.17-.2.18.17c.92.84,1.52,1.49,1.45,1.58s-.81-.42-1.77-1.21l.35,0-.65.81A9.78,9.78,0,0,1,239.16,405.2Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "241.2977590560913px 403.40000915527344px"
    },
    id: "elj2smv76ieb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.22,415.1a9.73,9.73,0,0,1,1.8-2.61l.67-.79.17-.19.18.16c.92.84,1.52,1.49,1.45,1.58s-.81-.42-1.77-1.2l.35,0-.65.81A9.85,9.85,0,0,1,241.22,415.1Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "243.3577642440796px 413.3050079345703px"
    },
    id: "elzb27ksfz4kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.08,449a9.73,9.73,0,0,1,1.8-2.61c.23-.26.44-.52.67-.79l.17-.2.18.17c.92.84,1.52,1.49,1.45,1.58s-.81-.42-1.77-1.21l.35,0-.65.81A9.78,9.78,0,0,1,247.08,449Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "249.21775722503662px 447.1999969482422px"
    },
    id: "elk1hcg2xlj3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,426.5a9.45,9.45,0,0,1,1.8-2.61l.67-.79.17-.2.18.17c.91.84,1.52,1.49,1.45,1.58s-.81-.42-1.77-1.21l.35,0-.65.81A10,10,0,0,1,242.7,426.5Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "244.83771300315857px 424.6999969482422px"
    },
    id: "elpnf60hsrx2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.21,434.86c0,.14-6,.26-13.35.26s-13.35-.12-13.35-.26,6-.26,13.35-.26S243.21,434.71,243.21,434.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "229.86000061035156px 434.8599853515625px"
    },
    id: "el0a7l251o3vd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,436.47a36.72,36.72,0,0,1-.23-3.93l.23.23-3.93,0,.26-.26h0v1c0,.35,0,.68,0,1,0,.64,0,1.26,0,1.85l-.22-.22a35.36,35.36,0,0,1,3.93.22,26.73,26.73,0,0,1-3.93.23h-.22v-.23c0-.59,0-1.21,0-1.85,0-.34,0-.67,0-1v-1h0c-.24.23.31-.32.26-.26l3.93,0h.23v.22A27.75,27.75,0,0,1,250,436.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.0695230960846px 434.41927909851074px"
    },
    id: "eld8sp1pqzg15",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.71,437.81a10,10,0,0,1,1.8-2.61c.23-.26.45-.52.67-.79l.17-.2.18.17c.92.84,1.53,1.49,1.45,1.57s-.81-.41-1.77-1.2l.35,0-.64.81A9.93,9.93,0,0,1,244.71,437.81Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "246.8485176563263px 436.00999450683594px"
    },
    id: "elwuwff042les",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.24,451.76c0-.15,5.42-.26,12.11-.26s12.12.11,12.12.26-5.42.26-12.12.26S132.24,451.9,132.24,451.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "144.3550033569336px 451.760009765625px"
    },
    id: "el1i9dl0j1wxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.06,450.29a29.88,29.88,0,0,1,.22,3.57l-.22-.22,3.57,0c.05-.06-.5.49-.27.26h0V452c0-.59,0-1.15,0-1.69l.23.23a28.19,28.19,0,0,1-3.57-.23,22.57,22.57,0,0,1,3.57-.22h.22v.23c0,.54,0,1.1,0,1.69v1.87h0l-.26.26-3.57,0h-.23v-.22A21.91,21.91,0,0,1,126.06,450.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "127.77999877929688px 452.1132354736328px"
    },
    id: "elkljaktgoe5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,449.08a8.26,8.26,0,0,1-1.62,2.38l-.61.72-.17.2-.18-.17c-.83-.76-1.38-1.36-1.3-1.45s.74.37,1.62,1.08l-.35,0,.58-.74C129.86,449.91,130.76,449,130.88,449.08Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "128.93615174293518px 450.72756028175354px"
    },
    id: "elazc0icdlcxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.42,444.65c0-.15,5.43-.26,12.12-.26s12.11.11,12.11.26-5.42.26-12.11.26S127.42,444.79,127.42,444.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "139.53499603271484px 444.6499938964844px"
    },
    id: "elzyldu6qopyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24,443.18a29.88,29.88,0,0,1,.22,3.57l-.22-.22,3.57,0-.26.26h0v-.95c0-.31,0-.62,0-.92,0-.59,0-1.15,0-1.69l.23.23a28.19,28.19,0,0,1-3.57-.23,22.72,22.72,0,0,1,3.57-.22H125v.23c0,.54,0,1.1,0,1.69,0,.3,0,.61,0,.92v.95h0l-.26.26-3.57,0H121v-.22A21.91,21.91,0,0,1,121.24,443.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.99815583229065px 445.033322095871px"
    },
    id: "eli125v6aq6ce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.06,442a8.26,8.26,0,0,1-1.62,2.38l-.61.72-.17.2-.18-.17c-.83-.76-1.37-1.36-1.3-1.45s.75.37,1.62,1.08l-.35,0L124,444C125,442.8,126,441.88,126.06,442Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "124.11695003509521px 443.6447479724884px"
    },
    id: "el17pn89jcuml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.78,436.62c0-.15,5.42-.26,12.11-.26s12.12.11,12.12.26-5.42.26-12.12.26S125.78,436.76,125.78,436.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.8949966430664px 436.6199951171875px"
    },
    id: "elu27cdlfs08e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6,435.15a29.66,29.66,0,0,1,.22,3.57l-.22-.22,3.56,0-.26.26h0v-1.87c0-.59,0-1.15,0-1.69l.22.23a28.13,28.13,0,0,1-3.56-.23,22.5,22.5,0,0,1,3.56-.22h.23v.23c0,.54,0,1.1,0,1.69v1.87h0c.23-.23-.32.32-.27.26l-3.56,0h-.23v-.22A21.91,21.91,0,0,1,119.6,435.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.34824252128601px 437.0055465698242px"
    },
    id: "el3wjc35st9tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41,433.94a7.87,7.87,0,0,1-1.61,2.38l-.61.72-.17.2-.18-.17c-.83-.76-1.38-1.36-1.3-1.45s.74.37,1.62,1.08l-.35,0,.58-.74C123.4,434.77,124.3,433.85,124.41,433.94Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "122.47114396095276px 435.5869793891907px"
    },
    id: "elti4hfrpzvlb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,428.41c0-.15,5.42-.27,12.11-.27s12.11.12,12.11.27-5.42.26-12.11.26S124,428.55,124,428.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "136.11000061035156px 428.40501403808594px"
    },
    id: "el64uiwza5g6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.82,426.94a28.19,28.19,0,0,1,.23,3.57l-.23-.23,3.57,0-.26.26h0v-.93c0-.32,0-.62,0-.93,0-.58,0-1.14,0-1.68l.23.23a30.84,30.84,0,0,1-3.57-.23,23.47,23.47,0,0,1,3.57-.23h.22v.23q0,.81,0,1.68c0,.31,0,.61,0,.93v.93h0l-.26.26-3.57,0h-.23v-.22A22.72,22.72,0,0,1,117.82,426.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.54999923706055px 428.7841947078705px"
    },
    id: "eluqwz9zo0pzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.64,425.73a8.16,8.16,0,0,1-1.62,2.38l-.61.72-.17.19-.18-.16c-.83-.77-1.37-1.36-1.3-1.45s.75.37,1.62,1.07l-.35,0,.59-.73C121.62,426.55,122.53,425.63,122.64,425.73Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "120.6969518661499px 427.37129068374634px"
    },
    id: "elxdcl8klj6aj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42,420.3c0-.14,5.42-.26,12.11-.26s12.11.12,12.11.26-5.42.26-12.11.26S119.42,420.45,119.42,420.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.52999877929688px 420.29998779296875px"
    },
    id: "elulth2j1f7w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.23,418.84a28.13,28.13,0,0,1,.23,3.56l-.23-.22,3.57,0-.26.26h0v-.95c0-.31,0-.62,0-.92q0-.87,0-1.68l.22.22a29.66,29.66,0,0,1-3.57-.22,21.91,21.91,0,0,1,3.57-.23H117v.23c0,.54,0,1.1,0,1.68,0,.3,0,.61,0,.92v.95h0c.23-.23-.32.32-.26.27l-3.57,0H113v-.23A22.5,22.5,0,0,1,113.23,418.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.02643752098083px 420.6849422454834px"
    },
    id: "elww5wbjki2lm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.05,417.62a8,8,0,0,1-1.62,2.38l-.61.72-.16.2-.19-.17c-.82-.76-1.37-1.36-1.29-1.44s.74.36,1.62,1.07l-.36,0,.59-.74C117,418.45,117.94,417.53,118.05,417.62Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "116.11114156246185px 419.26697194576263px"
    },
    id: "eli8qi6sfi4kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,379.82l.21,0,.62,0,2.4,0,8.94-.06,30.58,0h0a10.45,10.45,0,0,1,6.3,1.2,14,14,0,0,1,5,4.49,27.66,27.66,0,0,1,3.92,10.55c.71,3.57,1.22,7,1.65,10.35.89,6.61,1.43,12.61,2.49,17.52A51.71,51.71,0,0,0,256.68,435c.6,1.27,1.15,2.22,1.52,2.87.17.29.31.53.43.72a1.21,1.21,0,0,1,.13.26,1.11,1.11,0,0,1-.18-.23l-.47-.7a31.56,31.56,0,0,1-1.62-2.83,50.6,50.6,0,0,1-4.06-11.24c-1.12-5-1.69-10.93-2.6-17.54-.45-3.3-1-6.76-1.68-10.31a27.41,27.41,0,0,0-3.85-10.36,13.55,13.55,0,0,0-4.78-4.33,10,10,0,0,0-6-1.15h0L202.91,380l-8.94-.09-2.4-.05-.62,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "224.74999237060547px 409.26511001586914px"
    },
    id: "eljyhun1l2u9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.63,464.86a6.52,6.52,0,0,0,.85-.23,7.87,7.87,0,0,0,2.31-1.14,8.08,8.08,0,0,0,2.63-3.19,12.39,12.39,0,0,0,1-5.56,29,29,0,0,0-1-7.09,67.1,67.1,0,0,0-3-8c-.58-1.43-1.14-2.92-1.64-4.5a29.46,29.46,0,0,1-1.19-5,16.32,16.32,0,0,1,2-10.77A10.87,10.87,0,0,1,97,415.32a9.14,9.14,0,0,1,1.46-.55c.25-.06.5-.15.76-.2l.79-.1a5.15,5.15,0,0,1,3.13.65,15.93,15.93,0,0,1,4.79,4.4,40,40,0,0,1,3.6,5.71,46.4,46.4,0,0,1,2.76,6.4,26.33,26.33,0,0,1,1,3.46c.22,1.2.32,2.39.5,3.59a68.46,68.46,0,0,0,1.35,7.23,73.91,73.91,0,0,0,2.24,7.22,16.13,16.13,0,0,0,1.56,3.46,13.57,13.57,0,0,0,2.51,2.9,20.76,20.76,0,0,0,3.17,2.28,22.34,22.34,0,0,0,3.53,1.76,11.84,11.84,0,0,0,3.87.77c1.31,0,2.69-.15,4-.26a29.91,29.91,0,0,0,8-1.66,31.09,31.09,0,0,0,7.32-4,24.72,24.72,0,0,0,5.92-6,49.62,49.62,0,0,0,7.27-15.72,60.41,60.41,0,0,0,1.53-7.71c.33-2.58.48-5.18.7-7.76A131.69,131.69,0,0,1,170.7,406c.5-2.47,1.13-4.89,1.84-7.25a54.21,54.21,0,0,1,2.46-6.93,26.85,26.85,0,0,1,3.84-6.12,17.71,17.71,0,0,1,5.48-4.49l0,0a11.76,11.76,0,0,1,5.87-1.67,8.6,8.6,0,0,1,5.59,2.09,14.26,14.26,0,0,1,3.43,4.76,49,49,0,0,1,2.05,5.33A112.82,112.82,0,0,1,206,412.58c.94,6.69,1.42,13,1.84,18.89s1,11.28,2.53,16a28.65,28.65,0,0,0,6.34,11.36,19.47,19.47,0,0,0,8.14,5.2,16.54,16.54,0,0,0,6,.8c.69-.06,1.21-.12,1.56-.19l.53-.07-.52.11a11.6,11.6,0,0,1-1.57.23,16.06,16.06,0,0,1-6.06-.73,19.64,19.64,0,0,1-8.26-5.19,28.83,28.83,0,0,1-6.46-11.43c-1.52-4.71-2.16-10.16-2.6-16s-.93-12.19-1.88-18.86a113.37,113.37,0,0,0-4.81-20.76,47.12,47.12,0,0,0-2-5.28,13.73,13.73,0,0,0-3.31-4.6,8.15,8.15,0,0,0-5.3-2,11.34,11.34,0,0,0-5.62,1.61l0,0a17,17,0,0,0-5.29,4.35,26,26,0,0,0-3.76,6,53,53,0,0,0-2.43,6.86c-.71,2.36-1.33,4.76-1.83,7.21a132.29,132.29,0,0,0-1.94,15.12c-.21,2.57-.37,5.17-.69,7.79a63.68,63.68,0,0,1-1.54,7.78,50.33,50.33,0,0,1-7.36,15.88,25,25,0,0,1-6,6.14,31.5,31.5,0,0,1-7.44,4.06,30.82,30.82,0,0,1-8.15,1.69c-1.38.1-2.71.24-4.1.25a12.19,12.19,0,0,1-4-.8,22.24,22.24,0,0,1-3.62-1.81,21.26,21.26,0,0,1-3.23-2.34,13.53,13.53,0,0,1-2.6-3,16.63,16.63,0,0,1-1.6-3.56,72.41,72.41,0,0,1-2.25-7.27,69.78,69.78,0,0,1-1.34-7.28,34.09,34.09,0,0,0-4.15-13.31,38.46,38.46,0,0,0-3.54-5.65,15.55,15.55,0,0,0-4.65-4.3c-1.81-1.11-4-.61-5.78.19a10.4,10.4,0,0,0-4.22,3.93,16,16,0,0,0-2,10.53A28.59,28.59,0,0,0,92.13,435c.49,1.56,1,3,1.61,4.48a65.89,65.89,0,0,1,3,8.06,29.43,29.43,0,0,1,1,7.16,12.68,12.68,0,0,1-1.12,5.63,8.22,8.22,0,0,1-2.71,3.21,7.9,7.9,0,0,1-2.35,1.1A4.81,4.81,0,0,1,90.63,464.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.66251373291016px 422.2453956604004px"
    },
    id: "elvyb36zz7f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85,450.47s-.07,0-.18-.12-.29-.22-.5-.4a23.12,23.12,0,0,1-1.78-1.72,28.69,28.69,0,0,1-2.49-3,20,20,0,0,1-2.46-4.58,41.19,41.19,0,0,1-1.37-6.13c-.35-2.23-.63-4.62-1.06-7.1a25.37,25.37,0,0,0-2.4-7.46,13.88,13.88,0,0,0-2.4-3.33,5.31,5.31,0,0,0-1.61-1.25,8.92,8.92,0,0,0-2-.6,45.61,45.61,0,0,0-8.45-.43c-2.75,0-5.4.18-7.93.2l-13.45.12-9.07,0h-2.46a4.46,4.46,0,0,1-.86-.05,6.53,6.53,0,0,1,.86-.06l2.46-.08,9.06-.2,13.44-.23c2.53,0,5.18-.19,7.94-.23a45.37,45.37,0,0,1,8.56.43,8.76,8.76,0,0,1,2.14.64,4.28,4.28,0,0,1,1,.61c.27.24.54.48.79.75a14.23,14.23,0,0,1,2.48,3.45,25.6,25.6,0,0,1,2.42,7.61c.42,2.51.68,4.9,1,7.12a40.24,40.24,0,0,0,1.29,6.08,19.58,19.58,0,0,0,2.35,4.53,31.37,31.37,0,0,0,2.4,3.06c.71.79,1.29,1.38,1.7,1.77S160.86,450.46,160.85,450.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.61520957946777px 432.12264823913574px"
    },
    id: "elodyxowiw4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,148.14a6.71,6.71,0,0,1,3.59-5.8,2.29,2.29,0,0,1,1.11-.31,1,1,0,0,1,.92.59,1.13,1.13,0,0,1-.32,1.13,9.11,9.11,0,0,1-1,.77,3.59,3.59,0,0,0-1.23,3.45",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "373.8305594921112px 145.08498430252075px"
    },
    id: "eli76yeujkpy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.14,105.25a17.35,17.35,0,0,0-16,18.52c.91,13.5.63,31.84-5.82,43-11.16,19.32-27.9,22.75-26.62,61.38s3,42.72-4.72,52.7-24.46,4.82-31.76,27.57-2.15,136.49-13.74,148.51c0,0-9.44,9-19.31,8.15h55.46a18,18,0,0,0,12.68-5,14.27,14.27,0,0,0,4.4-10.43c0-7.83,2.57-118.46,6.87-127.91s26.61-19.08,30-40.87,2.22-57.05,2.19-63.39c0-6,1.17-17.78,12.71-31.51C376,165.22,373.61,142.54,374,134.81s-3-31-3-31Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "304.10062408447266px 284.4733123779297px"
    },
    id: "el5uckc703lie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.69,120.88a5.34,5.34,0,0,1,9.56-1.6c1.65,2.4,1.27,6,3.49,7.9,1.41,1.21,3.45,1.29,5.31,1.26a84.87,84.87,0,0,0,17.39-2.16L372.16,108s-27.75-2.44-31.13,2.12S337.69,120.88,337.69,120.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "355.56500816345215px 117.89632415771484px"
    },
    id: "el40yqboo9ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.37,130.25c0-4.12.93-7.75,1.9-11.75,1.17-4.84,4.54-8.37,8.63-9,5.17-.74,10.27,6.72,10.27,6.72s20.1-2.92,29.66-3.63c-.7-2.49-5.72-8.91-9.33-9.69a45.79,45.79,0,0,0-11-.59c-6.6.18-13.43.41-19.39,3.25s-12.1,7-10.65,22.34",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "361.53744316101074px 116.22865009307861px"
    },
    id: "elec4spxs9rmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.48,103.39a4.35,4.35,0,0,1-1,.12l-2.73.21c-2.3.17-5.48.41-9,.78s-6.66.82-8.93,1.22l-2.68.49a6,6,0,0,1-1,.15,5.61,5.61,0,0,1,1-.27c.63-.16,1.54-.36,2.67-.59,2.27-.45,5.43-1,8.93-1.31s6.69-.57,9-.69l2.73-.11A6.37,6.37,0,0,1,375.48,103.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "362.8100280761719px 104.8649787902832px"
    },
    id: "elarps91kuhkh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.21,322.94c0,.15-8.51,1.53-19,3.09s-19.1,2.71-19.12,2.57,8.5-1.52,19-3.09S313.19,322.8,313.21,322.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.14998054504395px 325.76996064186096px"
    },
    id: "el3ngf1r7kms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.22,318.78c0,.14-7.83.31-17.49.37s-17.5,0-17.5-.16,7.83-.31,17.49-.37S315.22,318.63,315.22,318.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "297.7250061035156px 318.8856950998306px"
    },
    id: "eltnja2jbn8ea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.66,465.21l1-.13a19.79,19.79,0,0,0,2.78-.57,31.09,31.09,0,0,0,9.71-4.84,34.79,34.79,0,0,0,2.94-2.33,9.06,9.06,0,0,0,2.22-3.39,45.77,45.77,0,0,0,2.4-9,221.29,221.29,0,0,0,2.52-22.76c1.17-16.94,1.65-37.16,2.35-59.6.37-11.23.74-23,1.68-35.21.24-3,.53-6.11.93-9.2a60.9,60.9,0,0,1,1.76-9.26c.5-1.51,1.08-3,1.65-4.49l1.07-2.15.54-1.08c.2-.34.43-.68.65-1a24.49,24.49,0,0,1,6.53-7.16,37.62,37.62,0,0,1,8.56-4.54,57.76,57.76,0,0,0,8.64-3.9l1-.62c.31-.23.6-.49.9-.73l.9-.73.78-.86c.25-.28.52-.56.77-.85l.69-.94c.48-.61.9-1.26,1.32-1.91a22.68,22.68,0,0,0,2.09-4.07,23.86,23.86,0,0,0,1.12-4.4,56.93,56.93,0,0,0,.51-9c0-3-.11-6-.21-8.9q-.35-8.81-.67-17.23c-.08-2.81-.25-5.57-.22-8.32,0-1.37,0-2.73,0-4.08s.14-2.69.2-4c.07-2.67.54-5.27.85-7.84a60.87,60.87,0,0,1,1.8-7.42,47.11,47.11,0,0,1,6.33-13,122.89,122.89,0,0,1,8.38-10.38,95.13,95.13,0,0,0,7.39-9.56l1.5-2.39c.5-.78.88-1.61,1.31-2.4a41.32,41.32,0,0,0,1.93-4.84,72,72,0,0,0,3-17c.32-4.74.31-8.43.29-10.92,0-1.24,0-2.19-.05-2.85s0-1,0-1,.11,1.31.17,3.81.09,6.2-.2,10.94a71.38,71.38,0,0,1-2.94,17,41.52,41.52,0,0,1-1.92,4.89c-.43.79-.81,1.64-1.32,2.42s-1,1.59-1.49,2.41a96,96,0,0,1-7.39,9.62A123.25,123.25,0,0,0,313,189.84a47,47,0,0,0-6.25,12.89A61.44,61.44,0,0,0,305,210.1c-.31,2.55-.76,5.13-.83,7.79-.06,1.32-.18,2.65-.2,4s0,2.7,0,4.07c0,2.72.15,5.5.23,8.3q.33,8.42.69,17.24c.1,2.93.21,5.9.21,8.91a55.87,55.87,0,0,1-.51,9.1,23.76,23.76,0,0,1-1.14,4.5,22.81,22.81,0,0,1-2.14,4.17c-.42.66-.85,1.32-1.33,1.94l-.7.94c-.26.31-.54.59-.8.89l-.81.89-.92.76c-.31.24-.61.51-.94.74l-1,.64a57.79,57.79,0,0,1-8.71,3.94,37,37,0,0,0-8.45,4.48,24,24,0,0,0-6.4,7c-.21.33-.44.66-.64,1l-.53,1.06-1,2.12c-.56,1.48-1.14,2.95-1.63,4.43a61.27,61.27,0,0,0-1.75,9.17c-.4,3.08-.69,6.14-.94,9.19-.94,12.17-1.32,23.95-1.7,35.17-.73,22.44-1.24,42.67-2.46,59.62A217.79,217.79,0,0,1,258,445a45.43,45.43,0,0,1-2.47,9.08,9,9,0,0,1-2.29,3.47,34.45,34.45,0,0,1-3,2.32,30.59,30.59,0,0,1-9.8,4.78,17.61,17.61,0,0,1-2.8.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "286.6848335266113px 296.7849884033203px"
    },
    id: "el8rfnwcs4f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.43,128.32l-.09-1.26c0-.85-.13-2.08-.23-3.71a18.86,18.86,0,0,1,.1-2.74c.11-1,.38-2.08.61-3.25a15.73,15.73,0,0,1,3.73-7.3,24,24,0,0,1,8.78-5.41,45.1,45.1,0,0,1,12.05-2.54c2.21-.19,4.5-.29,6.87-.33a25.43,25.43,0,0,1,7.29.76,21.53,21.53,0,0,1,3.62,1.31,15.88,15.88,0,0,1,3.29,2.2,19.09,19.09,0,0,1,2.84,2.91,10.91,10.91,0,0,1,1.13,1.75,4.77,4.77,0,0,1,.62,2.06v.17h-.18c-4.49.39-9.3,1.38-14.34,2l.18-.22c.59,4.88,1.19,10,1.51,15.23.07,1.31.12,2.65.1,4s-.1,2.68-.1,4c0,2.72,0,5.48-.21,8.28a75.52,75.52,0,0,1-2.88,17,64,64,0,0,1-7.58,16.43c-3.32,5.25-7.9,9.68-11,15.28a45.47,45.47,0,0,0-6.21,18.25,82.53,82.53,0,0,0-.12,10q.06,5,.12,10.14c.05,6.8,0,13.69-.23,20.65-.28,8-.7,16-1.72,23.74a43,43,0,0,1-2.76,11.34,44.16,44.16,0,0,1-5.87,9.88c-4.69,6-10.52,10.77-15.86,15.68L318,316.55c-.61.66-1.23,1.31-1.82,2l-.81,1.06a6,6,0,0,0-.74,1.09l-.65,1.15a12.63,12.63,0,0,0-.44,1.22,83.91,83.91,0,0,0-1.55,10.4c-1.33,13.84-1.95,27.06-2.55,39.42s-1,23.88-1.36,34.4-.63,20-.85,28.39q-.14,6.27-.26,11.64a31.9,31.9,0,0,1-.28,5.15,13.65,13.65,0,0,1-1.58,4.39,16.21,16.21,0,0,1-5.4,5.61,17.9,17.9,0,0,1-5.28,2.23,18.28,18.28,0,0,1-3.49.52c-.79,0-1.2,0-1.2,0l.3,0c.2,0,.5,0,.9-.05a18.5,18.5,0,0,0,8.68-2.82,16.08,16.08,0,0,0,5.31-5.58,13.58,13.58,0,0,0,1.54-4.33,31.31,31.31,0,0,0,.25-5.11c.07-3.58.14-7.47.22-11.65.19-8.36.44-17.88.77-28.4s.74-22,1.29-34.4,1.19-25.58,2.51-39.45A83.41,83.41,0,0,1,313,322.92c.15-.43.27-.89.46-1.3l.68-1.19a6.57,6.57,0,0,1,.76-1.13l.83-1.08c.6-.69,1.22-1.35,1.84-2l2-1.9c5.36-4.94,11.16-9.66,15.8-15.63a43.76,43.76,0,0,0,5.8-9.76,43.25,43.25,0,0,0,2.72-11.21c1-7.75,1.43-15.68,1.71-23.7.23-6.95.28-13.83.23-20.63q-.06-5.1-.12-10.13a83.68,83.68,0,0,1,.13-10,45.81,45.81,0,0,1,6.29-18.45c3.13-5.66,7.74-10.12,11-15.3a63.14,63.14,0,0,0,7.55-16.3,75.53,75.53,0,0,0,2.88-16.9c.16-2.79.2-5.55.22-8.27,0-1.35.06-2.73.1-4s0-2.66-.09-4c-.31-5.25-.9-10.33-1.48-15.21l0-.2.2,0c5-.62,9.83-1.6,14.37-2l-.18.19a7,7,0,0,0-1.66-3.59,19.3,19.3,0,0,0-2.78-2.86,16.13,16.13,0,0,0-3.21-2.16,22.37,22.37,0,0,0-3.56-1.3,25.38,25.38,0,0,0-7.2-.76c-2.36,0-4.64.12-6.84.31a44.51,44.51,0,0,0-12,2.48,23.81,23.81,0,0,0-8.72,5.31,15.67,15.67,0,0,0-3.73,7.2c-.23,1.16-.52,2.23-.62,3.23a16.38,16.38,0,0,0-.13,2.72c.08,1.62.14,2.86.18,3.7S336.43,128.32,336.43,128.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "338.3900146484375px 283.48941802978516px"
    },
    id: "el54ibfvhezh6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.85,112.77a2.19,2.19,0,0,1-.56.12l-1.64.24-6,.79-19.85,2.42-1.59.19-.16,0-.08-.13a25.59,25.59,0,0,0-3.34-4.2,8.73,8.73,0,0,0-4.19-2.4,8.55,8.55,0,0,0-4.35.26,8.09,8.09,0,0,0-3.24,2,14.41,14.41,0,0,0-3,4.74c-.23.62-.4,1.11-.5,1.45a4.71,4.71,0,0,1-.17.5,1.63,1.63,0,0,1,.07-.53,13.92,13.92,0,0,1,.42-1.49,13.76,13.76,0,0,1,2.88-4.92,8.53,8.53,0,0,1,3.36-2.16,8.9,8.9,0,0,1,4.59-.32,9,9,0,0,1,4.44,2.5,25.32,25.32,0,0,1,3.42,4.27l-.25-.11,1.59-.19,19.87-2.27,6-.63,1.64-.15A2.55,2.55,0,0,1,386.85,112.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "362.51454734802246px 113.95834302902222px"
    },
    id: "elkc7lr56a53",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,149.92a1.27,1.27,0,0,1-.82,1.14l-6,2.27c-.92.35-2.15.61-2.72-.19a1.54,1.54,0,0,1,.24-1.85,4.47,4.47,0,0,1,1.7-1c2.31-1,4.84-1.94,7.18-2.91a.34.34,0,0,1,.47.34Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "369.1530680656433px 150.5101990699768px"
    },
    id: "elqs4kaggxd39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.23,151.93a2.55,2.55,0,0,1-1.57,2.93L367.09,157c-.92.35-2.15.61-2.72-.18a1.54,1.54,0,0,1,.24-1.85,4.37,4.37,0,0,1,1.7-1c2.21-.92,4.62-1.85,6.86-2.77a.73.73,0,0,1,1,.52Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "369.22793531417847px 154.23985147476196px"
    },
    id: "elz5wn2utpbqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,154.92a3.69,3.69,0,0,1-2.28,4.31L366.31,161c-.92.35-2.15.61-2.72-.19a1.56,1.56,0,0,1,.24-1.85,4.58,4.58,0,0,1,1.71-1c2.47-1,5.2-2.08,7.66-3.11Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "368.3610529899597px 158.09331941604614px"
    },
    id: "el8r80qwgm0uc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,202.35c0,.14-7.31,2.85-16.43,6.06s-16.56,5.71-16.61,5.57,7.31-2.85,16.43-6.06S348.67,202.21,348.72,202.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "332.19987869262695px 208.16501331329346px"
    },
    id: "elf7hnoc788mk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.77,206.35a18.56,18.56,0,0,1-2.66,1.9c-1.68,1.11-4,2.59-6.69,4.16s-5.08,2.93-6.86,3.87a17.77,17.77,0,0,1-2.94,1.42,22.63,22.63,0,0,1,2.76-1.74l6.78-4,6.76-4A21.79,21.79,0,0,1,344.77,206.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.19500732421875px 212.02499389648438px"
    },
    id: "el1atwsmz7e1n",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-47",
    style: {
      transformOrigin: "200.5829620361328px 91.68439865112305px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.66,83.64a1.62,1.62,0,0,1,0,.33c0,.24,0,.54,0,.9,0,.83,0,2,.05,3.36,0,2.91.07,7,.12,11.81l-.23-.22,16.4,0c.06,0-.49.49-.25.26h0V91.38c0-2.75,0-5.35,0-7.74l.23.23-11.82-.12-3.36-.06-.9,0-.33,0a9.59,9.59,0,0,1,1.14,0l3.3-.06,12-.11h.22v.23c0,2.39,0,5,0,7.74V100h0c.23-.23-.32.32-.27.26l-16.4,0h-.22V100c.05-4.9.09-9,.11-12,0-1.38,0-2.48.06-3.31S190.65,83.62,190.66,83.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.81325244903564px 91.89230632781982px"
    },
    id: "el7rn0rw7vmz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.49,80c.33.27-3.15,5.06-7.77,10.68-1,1.18-1.9,2.3-2.77,3.32l-.51.58-.55-.49c-3.84-3.46-6.44-6.09-6.22-6.35s3.21,1.93,7.19,5.23l-1.05.09c.82-1.05,1.74-2.19,2.71-3.37C206.14,84.05,210.15,79.7,210.49,80Z",
    style: {
      fill: "rgb(144, 202, 249)",
      transformOrigin: "201.58434581756592px 87.28268337249756px"
    },
    id: "elshhk658tuy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.57,68h-.41L199,68c-.26,0-.56,0-.88,0l-1.06.15-1.24.18-1.38.34a22.28,22.28,0,0,0-6.69,2.92,23.63,23.63,0,0,0-10.85,17.75,24.88,24.88,0,0,0-.07,3.24c0,.55,0,1.1.11,1.65s.17,1.11.25,1.67a23.71,23.71,0,0,0,2.25,6.59,25.41,25.41,0,0,0,4.3,5.92,25,25,0,0,0,6.2,4.45,22.41,22.41,0,0,0,7.56,2.32,15,15,0,0,0,2,.17,17.36,17.36,0,0,0,2,0,24.62,24.62,0,0,0,4.08-.52,23.88,23.88,0,0,0,8.12-3.41l-.24,0,8.27,3.32.49.2-.14-.51c-.83-3-1.65-6-2.43-8.85l0,.22A23.69,23.69,0,0,0,224,95.78a21.1,21.1,0,0,0,.32-5.17,15.68,15.68,0,0,0-.23-2.49c-.06-.41-.13-.81-.19-1.21s-.19-.79-.29-1.17a23.65,23.65,0,0,0-9.23-13.46,22.74,22.74,0,0,0-5.49-2.9l-1.24-.44-1.18-.3-1.07-.27-1-.15c-.63-.08-1.18-.18-1.66-.21l-1.21,0-.75,0h-.25a1.08,1.08,0,0,0,.25,0l.74.06,1.21.08c.48,0,1,.16,1.64.25a23.51,23.51,0,0,1,18.82,17.45c.09.38.21.76.28,1.15s.11.79.17,1.19a15.16,15.16,0,0,1,.22,2.44,20.85,20.85,0,0,1-.33,5.08,23.43,23.43,0,0,1-4.36,9.89l-.07.1,0,.12,2.42,8.85.35-.31L213.67,111l-.13-.06-.12.08a23.2,23.2,0,0,1-11.93,3.84,18.84,18.84,0,0,1-2,0,14.28,14.28,0,0,1-2-.17,21.85,21.85,0,0,1-7.39-2.26,24.19,24.19,0,0,1-6.07-4.34,25,25,0,0,1-4.23-5.79,23.34,23.34,0,0,1-2.22-6.44c-.09-.55-.17-1.1-.26-1.64s-.07-1.08-.11-1.62a25.84,25.84,0,0,1,.05-3.18,23.37,23.37,0,0,1,10.57-17.54,22.67,22.67,0,0,1,6.59-3l1.36-.36,1.22-.2,1.05-.18.88-.06,1.2-.09A1.87,1.87,0,0,0,200.57,68Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "200.58296394348145px 91.68440055847168px"
    },
    id: "ell3s25u26wn8",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopendingdata);
export default __webpack_public_path__ + "static/media/nopendingdata.51143a342af68a291fd0ef8768aaf9e2.svg";
export { ForwardRef as ReactComponent };